import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { Star } from 'lucide-react';
export function ContentsSection() {
  const chapters = [{
    title: 'El Ciclo de la Glucosa al Descubierto',
    desc: 'Entiende exactamente por qué tu cuerpo te pide azúcar y cómo apagar esa alarma.'
  }, {
    title: 'La Secuencia de Oro Paso a Paso',
    desc: 'El manual exacto para ordenar tus comidas y blindar tu metabolismo desde hoy.'
  }, {
    title: 'Plantillas del Escudo Metabólico',
    desc: 'Ejemplos visuales y fáciles para armar tus platos sin tener que pensar demasiado.'
  }, {
    title: 'Desayunos, Almuerzos y Cenas Reales',
    desc: 'Opciones deliciosas con ingredientes latinos que ya tienes en tu cocina.'
  }, {
    title: 'Estrategias de Snacks Inteligentes',
    desc: 'Qué comer entre comidas para mantener la energía alta sin disparar tu azúcar.'
  }, {
    title: 'Guía para Comer Fuera de Casa',
    desc: 'Cómo ir a restaurantes o fiestas sin perder tu progreso ni sentirte excluido.'
  }, {
    title: 'El Protocolo Cero Antojos Nocturnos',
    desc: 'La rutina exacta para apagar el hambre que aparece justo antes de dormir.'
  }, {
    title: 'Plan de Acción Rápida de 7 Días',
    desc: 'Un mapa paso a paso para ver resultados reales y sentir la diferencia en tu primera semana.'
  }];
  return <section className="py-16 md:py-24 bg-white px-4" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <FadeInSection data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-44">
            Esto es exactamente lo que encontrarás dentro del eBook:
          </h2>

          <div className="space-y-6" data-id="element-45">
            {chapters.map((chapter, index) => <div key={index} className="flex items-start p-6 bg-gray-50 rounded-2xl border border-gray-100 hover:border-green-200 transition-colors" data-id="element-46">
                <Star className="w-6 h-6 text-amber-500 mr-4 flex-shrink-0 mt-1 fill-amber-500" data-id="element-47" />
                <div data-id="element-48">
                  <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-49">
                    {chapter.title}
                  </h3>
                  <p className="text-gray-600 text-lg" data-id="element-50">{chapter.desc}</p>
                </div>
              </div>)}
          </div>
        </FadeInSection>
      </div>
    </section>;
}